import React from "react";
import { BaseCustomizationEntry, defaultWebchatOptions, IAppState, WebchatOptions } from "../../Redux/reduxState";
import { connect } from "react-redux";
import { actionTypes, genericSingleAction } from "../../Redux/actions";
import { Dispatch, AnyAction } from 'redux';
import { diff } from "deep-object-diff";
import { transformWebchatOptions } from "./webChatJsonEditor";
import { CustomizationEntrySelector } from "./customizationEntrySelector";
import { ContainerName } from "../../Redux/reducers/AppReducer";
import { mergeStyles, TextField } from "@fluentui/react";
import { Breadcrumb, IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { EditorMode } from "../../utilities/types";

interface LocatedCustomizationEntry extends BaseCustomizationEntry {
    category: string;
    subCategory?: string;
}

const searchDivider = mergeStyles(
    {
        width: '100%',
        height: 1,
        backgroundColor: 'var(--druid-color-border)',
        margin: 'var(--druid-space-16) 0',
    }
);

const searchResult = (isLast: boolean) => mergeStyles({
    marginBottom: isLast ? 0 : 'var(--druid-space-16)',
    borderBottom: isLast ? 'none' : '1px solid var(--druid-color-border)',
});

const resultBreadcrumb = mergeStyles(
    {
        margin: 0,
        '.ms-Breadcrumb-list': {
            alignItems: 'center',
            marginBottom: 'var(--druid-space-4)'
        },
        '.ms-Breadcrumb-listItem': {
            lineHeight: 1,
        },
        '.ms-Breadcrumb-itemLink, .ms-Breadcrumb-item': {
            height: 'auto',
            padding: '0 var(--druid-space-4)',
            fontSize: 'var(--druid-font-size-base)',
            fontWeight: 'var(--druid-font-weight-normal) !important',
            color: 'var(--druid-color-text-secondary) !important',
            lineHeight: 'var(--druid-line-height-tight)',
        },
        '.ms-Breadcrumb-listItem:first-child .ms-Breadcrumb-itemLink, .ms-Breadcrumb-listItem:first-child .ms-Breadcrumb-item': {
            marginLeft: 0,
            paddingLeft: 0,
        },
        '.ms-Breadcrumb-itemLink:hover': {
            backgroundColor: 'transparent',
            color: 'var(--druid-color-success-primary) !important',
        },
        '.ms-Breadcrumb-chevron': {
            fontSize: 'var(--druid-font-size-xs)',
            color: 'var(--druid-color-text-disabled)',
            margin: '0 var(--druid-space-2)',
        },
        '.ms-Breadcrumb-listItem:last-child .ms-Breadcrumb-item': {
            padding: 0,
            margin: 0,
        },
    }
);

interface StateProps {
    initialized: boolean;
    currentStyleOptions: Partial<WebchatOptions>;
    customizationEntries: LocatedCustomizationEntry[];
    defaultContainerName: ContainerName;
    webchatOptions: WebchatOptions;
    editorMode: EditorMode;
}

interface DispatchProps {
    updateStyleElement: (styleElementName: string, containerName: ContainerName, value: any) => void;
    updateRootStateVariable: (stateVariableName: string, value: any) => void;
}

interface Props {

}
interface LocalState {
    textValue?: string,
}

type PropsType = StateProps & DispatchProps & Props;

export class WebChatOptionsSearch  extends React.Component<PropsType, LocalState> {
    constructor(props: PropsType) {
        super(props);
        this.state = ({
            textValue: "",
          
        })
    }
    
    private navigateTo = (entry: LocatedCustomizationEntry, openSubCategory: boolean) => {
        const { editorMode, updateRootStateVariable } = this.props;
        const categoryStateVariable = editorMode === EditorMode.VoiceSnippet ? 'activeVoiceCategory' : 'activeCategory';

        updateRootStateVariable('navigationTarget', {
            category: entry.category,
            subCategory: openSubCategory ? entry.subCategory : undefined,
            entryId: entry.id,
        });
        updateRootStateVariable(categoryStateVariable, entry.category);
    };

    private getBreadcrumbItems = (entry: LocatedCustomizationEntry): IBreadcrumbItem[] => {
        const items: IBreadcrumbItem[] = [{
            text: entry.category,
            key: `${entry.id}-category`,
            onClick: () => this.navigateTo(entry, false),
        }];

        if (entry.subCategory) {
            items.push({
                text: entry.subCategory,
                key: `${entry.id}-subcategory`,
                onClick: () => this.navigateTo(entry, true),
            });
        }

        return items;
    };

    getStyleOptionValue = (key: any, containerName?: ContainerName) => {
        const { webchatOptions, defaultContainerName } = this.props;
        const resolvedContainerName = containerName || defaultContainerName;
        return this.prop(resolvedContainerName === "root" ? webchatOptions : resolvedContainerName === "UI.headerOptions" ? webchatOptions["UI"]["headerOptions"]: webchatOptions[resolvedContainerName], key);// || this.prop(webchatOptions["UI"], key);
    };

    prop<T, K extends keyof T>(obj: T, key: K) {
        if(!obj) {
            return null;
        }
        return obj[key];
    }

    render() {
        const { customizationEntries, updateStyleElement } = this.props;
        const filterValue = this.state.textValue?.toLocaleLowerCase();
        const filteredCustomizationEntries = customizationEntries.filter(c => filterValue && filterValue.length >= 3
            && (c.displayName.toLocaleLowerCase().indexOf(filterValue.trim()) > -1 || c.id.toLocaleLowerCase().indexOf(filterValue.trim()) > -1));
        return  (<>
        {/* <p>{`Search:`}</p> */}
        <TextField multiline={false}
        placeholder={"Type a minimum of 3 characters to search..."}
        onChange={(e: any, newValue?: string) => {this.setState({
            textValue: newValue
        })}}/>
        <div className={searchDivider}></div>
        {
            filteredCustomizationEntries && filteredCustomizationEntries.length ? filteredCustomizationEntries.map((entry: LocatedCustomizationEntry, index: number) => (
                <div key={entry.id} className={searchResult(index === filteredCustomizationEntries.length - 1)}>
                    <Breadcrumb
                        className={resultBreadcrumb}
                        items={this.getBreadcrumbItems(entry)}
                        ariaLabel={`Location of ${entry.displayName}`}
                        overflowIndex={0}
                        maxDisplayedItems={4}
                    />
                    <CustomizationEntrySelector
                        entry={entry}
                        value={this.getStyleOptionValue(entry.id, entry.containerName)}
                        onChange={updateStyleElement}
                        getStyleOptionValue={(key, containerName) => this.getStyleOptionValue(key, containerName || entry.containerName)}
                    />
                </div>))
                :
                <div>
                    <strong>No items match your search</strong>
                </div>
        }
        </>)


    }
}

const mapStateToProps = (state: IAppState, ownProps: Props): StateProps => ({
    initialized: state.initialized,
    currentStyleOptions: { ...diff(defaultWebchatOptions(), transformWebchatOptions(state.webchatOptions)), customDruidStyleSet: state.webchatOptions.customDruidStyleSet },
    customizationEntries: state.editorMode === EditorMode.VoiceSnippet ? state.voiceCustomizationEntries : state.customizationEntries,
    defaultContainerName: state.editorMode === EditorMode.VoiceSnippet ? "VoiceUI" : "styleOptions",
    webchatOptions: state.webchatOptions,
    editorMode: state.editorMode,

});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchProps => ({
    updateStyleElement: (styleElementName: string, value: any, containerName?: ContainerName) => {
        dispatch(genericSingleAction<any>(actionTypes.UPDATE_STYLE_ELEMENT, { styleElementName: styleElementName, value: value, containerName: containerName }));
    },
    updateRootStateVariable: (stateVariableName: string, value: any) => {
        dispatch(genericSingleAction<any>(actionTypes.UPDATE_ROOT_WEBCHAT_STATE_VARIABlE, { propertyName: stateVariableName, value: value }));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WebChatOptionsSearch);